const toNumber = (value, fallback = 0) => {
  const num = Number(value);
  return Number.isFinite(num) ? num : fallback;
};

const hasDiscount = (source) =>
  Boolean(source?.discount) &&
  toNumber(source?.discountPercentage, 0) > 0;

export const variantBasePrice = (product, variant) => {
  if (variant) {
    if (variant.priceOverride != null) {
      return toNumber(variant.priceOverride);
    }
    if (variant.price != null) {
      return toNumber(variant.price);
    }
  }


  if (product?.sellingPrice != null) {
    return toNumber(product.sellingPrice);
  }

  return 0;
};

export const resolvePriceInfo = (product, variant = null) => {
  const base = variantBasePrice(product, variant);
  const variantHasDiscount = hasDiscount(variant);
  const productHasDiscount = hasDiscount(product);
  const discountSource = variantHasDiscount
    ? variant
    : productHasDiscount
    ? product
    : null;

  const percentage = discountSource
    ? toNumber(discountSource.discountPercentage, 0)
    : 0;
  const hasActiveDiscount = percentage > 0;

  const current = hasActiveDiscount
    ? Number((base * (1 - percentage / 100)).toFixed(2))
    : base;

  let original = null;
  if (hasActiveDiscount) {
    original = base;
  } else if (variant?.oldPrice != null) {
    original = toNumber(variant.oldPrice);
  } else if (product?.oldPrice != null) {
    original = toNumber(product.oldPrice);
  }

  return {
    current,
    original,
    showOriginal: Boolean(original && original !== current),
  };
};

/** 2,180 or 970.20: cents only when there are any, thousands separated (no currency sign). */
export const formatAmount = (value) => {
  const n = toNumber(value, 0);
  const hasCents = Math.round(n * 100) % 100 !== 0;
  const [whole, cents] = n.toFixed(hasCents ? 2 : 0).split('.');
  return whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + (cents ? `.${cents}` : '');
};
